 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"auth~bind~category-tool~detail~h5~h5-auth~image-preview~index~legacy~list~material-extract~pdf~rag~s~4920f303":"auth~bind~category-tool~detail~h5~h5-auth~image-preview~index~legacy~list~material-extract~pdf~rag~s~4920f303","auth":"auth","bind":"bind","category-tool~detail~image-preview~index~legacy~list~material-extract~pdf~rag~scholar~smart-classify~65dfaf7e":"category-tool~detail~image-preview~index~legacy~list~material-extract~pdf~rag~scholar~smart-classify~65dfaf7e","category-tool":"category-tool","detail":"detail","h5~legacy~list~pdf":"h5~legacy~list~pdf","legacy":"legacy","list":"list","pdf~rag~upload":"pdf~rag~upload","pdf":"pdf","h5~static~upload":"h5~static~upload","static":"static","image-preview~smart-classify":"image-preview~smart-classify","image-preview":"image-preview","smart-classify":"smart-classify","index":"index","material-extract":"material-extract","upload":"upload","rag":"rag","scholar":"scholar","h5-auth":"h5-auth","h5":"h5","error":"error"}[chunkId]||chunkId) + "." + {"auth~bind~category-tool~detail~h5~h5-auth~image-preview~index~legacy~list~material-extract~pdf~rag~s~4920f303":"1800a8e1","auth":"7c505dd8","bind":"ed1cf7e9","category-tool~detail~image-preview~index~legacy~list~material-extract~pdf~rag~scholar~smart-classify~65dfaf7e":"b31d2818","category-tool":"69054c8c","detail":"743422f1","h5~legacy~list~pdf":"7de77309","legacy":"762d35dd","list":"03bc753f","pdf~rag~upload":"29cfe978","pdf":"11f6039c","h5~static~upload":"77b9b75a","static":"1e4a44a9","image-preview~smart-classify":"2725b78f","image-preview":"7b0cf3ff","smart-classify":"de3c88e9","index":"887b78cc","material-extract":"e0def745","upload":"fa7aef1b","rag":"b7645a18","scholar":"12d987e0","h5-auth":"2bbf4f67","h5":"6d7c1313","error":"314a141e"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"auth":1,"bind":1,"category-tool~detail~image-preview~index~legacy~list~material-extract~pdf~rag~scholar~smart-classify~65dfaf7e":1,"category-tool":1,"detail":1,"legacy":1,"list":1,"pdf":1,"static":1,"image-preview":1,"smart-classify":1,"index":1,"material-extract":1,"upload":1,"rag":1,"scholar":1,"h5-auth":1,"h5":1,"error":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"auth~bind~category-tool~detail~h5~h5-auth~image-preview~index~legacy~list~material-extract~pdf~rag~s~4920f303":"auth~bind~category-tool~detail~h5~h5-auth~image-preview~index~legacy~list~material-extract~pdf~rag~s~4920f303","auth":"auth","bind":"bind","category-tool~detail~image-preview~index~legacy~list~material-extract~pdf~rag~scholar~smart-classify~65dfaf7e":"category-tool~detail~image-preview~index~legacy~list~material-extract~pdf~rag~scholar~smart-classify~65dfaf7e","category-tool":"category-tool","detail":"detail","h5~legacy~list~pdf":"h5~legacy~list~pdf","legacy":"legacy","list":"list","pdf~rag~upload":"pdf~rag~upload","pdf":"pdf","h5~static~upload":"h5~static~upload","static":"static","image-preview~smart-classify":"image-preview~smart-classify","image-preview":"image-preview","smart-classify":"smart-classify","index":"index","material-extract":"material-extract","upload":"upload","rag":"rag","scholar":"scholar","h5-auth":"h5-auth","h5":"h5","error":"error"}[chunkId]||chunkId) + "." + {"auth~bind~category-tool~detail~h5~h5-auth~image-preview~index~legacy~list~material-extract~pdf~rag~s~4920f303":"31d6cfe0","auth":"a3bee523","bind":"5fed8d76","category-tool~detail~image-preview~index~legacy~list~material-extract~pdf~rag~scholar~smart-classify~65dfaf7e":"b3d2f205","category-tool":"5efcd383","detail":"e8b02f8d","h5~legacy~list~pdf":"31d6cfe0","legacy":"504cb78f","list":"6f95f0a9","pdf~rag~upload":"31d6cfe0","pdf":"2d94c894","h5~static~upload":"31d6cfe0","static":"3405bbdb","image-preview~smart-classify":"31d6cfe0","image-preview":"d6814238","smart-classify":"837d9477","index":"1f6ddaf4","material-extract":"c55c44e6","upload":"08910ebc","rag":"114ce2a5","scholar":"9aaa2e4e","h5-auth":"3243993f","h5":"db4c94ff","error":"beaee343"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
